<template>
    <div class="excellent_box" v-if="visible">
        <div class="excellent_main import-dialog-main">
            <div class="excellent_top">
                导入品牌型号
                <i class="el-icon-close" @click.stop="close"></i>
            </div>
            <div class="excellent_content import-dialog-content">
                <div class="import-actions flex">
                    <div class="import-btn">
                        <el-button size="medium" type="primary" @click="triggerFileSelect">选择文件</el-button>
                        <input ref="fileInput" type="file" accept=".xlsx,.xls" style="display: none"
                            @change="onFileSelected" />

                    </div>
                    <div class="file-name">
                        <span v-if="fileName" class="file-name">{{ fileName }}</span>
                    </div>
                </div>
                <div class="import-tip">支持 .xlsx/.xls 格式，请按照模板格式填写数据</div>
            </div>
            <div class="excellent_btn flex">
                <el-button size="medium" type="info" @click="downloadTemplate"
                    style="margin-right: 40px;">下载模板</el-button>
                <el-button size="medium" type="success" :loading="loading" :disabled="!file"
                    @click="submit">上传</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BrandUpload",
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            file: null,
            fileName: "",
            loading: false
        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.reset();
            }
        }
    },
    methods: {
        reset() {
            this.file = null;
            this.fileName = "";
            this.loading = false;
        },

        close() {
            this.$emit("close");
        },

        triggerFileSelect() {
            this.$refs.fileInput.click();
        },

        onFileSelected(event) {
            const file = event.target.files[0];
            if (!file) return;

            const fileName = file.name;
            if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
                this.$message.error('请选择 .xlsx 或 .xls 格式的 Excel 文件');
                return;
            }

            this.file = file;
            this.fileName = fileName;
        },

        downloadTemplate() {
            this.$https(this.$api.api.downloadTemplate, {}, 'FILE').then((res) => {
                const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = '品牌型号导入模板.xlsx';
                link.click();
                window.URL.revokeObjectURL(url);
                this.$message.success('模板下载成功');
            }).catch(() => {
                this.$message.error('模板下载失败');
            });
        },

        submit() {
            if (!this.file) {
                this.$message.error('请选择要上传的文件');
                return;
            }

            this.loading = true;
            const formData = new FormData();
            formData.append('file', this.file);

            this.$https(this.$api.api.uploadBrandTypeInfo, formData, 'POST', {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then((res) => {
                this.loading = false;
                if (res.data.code == 200) {
                    const data = res.data.data || {};
                    const successCount = data.successCount || 0;
                    const failCount = data.failCount || 0;

                    if (failCount > 0) {
                        this.$message.warning(`上传完成，成功 ${successCount} 条，失败 ${failCount} 条`);
                        if (data.errorList && data.errorList.length > 0) {
                            this.downloadErrorExcel(data.errorList);
                        }
                    } else {
                        this.$message.success(`上传成功，共处理 ${successCount} 条`);
                        this.$emit("success");
                        this.close();
                    }
                } else {
                    this.$message.error(res.data.msg || '上传失败');
                }
            }).catch((err) => {
                this.loading = false;
                this.$message.error('上传失败：' + (err.message || '网络错误'));
            });
        },

        downloadErrorExcel(errorList) {
            this.$https(this.$api.api.exportTypeErrorExcel, errorList, 'FILE').then((res) => {
                const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = '品牌型号导入异常报告.xlsx';
                link.click();
                window.URL.revokeObjectURL(url);
                this.$message.success('异常报告已下载');
            }).catch(() => {
                this.$message.error('异常报告下载失败');
            });
        }
    }
};
</script>

<style lang="less" scoped>
.excellent_box {
    width: 100%;
    height: 100vh;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    background: rgba(000, 000, 000, 0.5);

    .excellent_main {
        width: 500px;
        height: 280px;
        margin: auto;
        background: #fff;
        transform: translate(-50%, -50%);
        position: fixed;
        left: 50%;
        top: 50%;
        border-radius: 5px;
        overflow: hidden;

        .excellent_top {
            width: 96%;
            height: 40px;
            background: #eee;
            line-height: 40px;
            padding: 5px 2%;
            font-size: 15px;

            i {
                float: right;
                margin-top: 10px;
                font-size: 20px;
                cursor: pointer;
            }
        }

        .excellent_content {
            width: 100%;
            margin-top: 10px;

            .excellent_li {
                margin-top: 25px;
            }
        }

        .excellent_btn {
            justify-content: center;
            margin: 25px 15px 0px 0px;
        }
    }
}

.import-dialog-main {
    width: 500px;
    height: 280px;

    .import-dialog-content {
        padding: 20px;

        .import-actions {
            align-items: center;
            margin-bottom: 15px;

            .import-btn {}

            .file-name {
                margin-left: 10px;
                color: #409eff;
                font-size: 14px;
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .import-tip {
            color: #999;
            font-size: 12px;
            margin-top: 10px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/brand/uploadModal.vue